import {CommonModule} from '@angular/common';
import {AfterContentChecked, ChangeDetectorRef, Component} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {StzhComponentsAngularModule} from '@oiz/stzh-components-angular';
import {StzhHeaderMenuItem, StzhHeaderMetanavItem} from '@oiz/stzh-components';
import {NgProgressbar} from 'ngx-progressbar';
import {Observable, of} from 'rxjs';
import {filter, map, switchMap, tap} from 'rxjs/operators';
import {Ausschreibung} from './model/ausschreibung';
import {AusschreibungService} from './service/ausschreibung.service';

@Component({
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, NgProgressbar, StzhComponentsAngularModule],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true
})
export class AppComponent implements AfterContentChecked {
  year = new Date().getFullYear();
  selectedAusschreibungTitle = '';
  id = '-1';
  angebot = false;
  signedIn = false;
  isLanding = false;

  headerMenuItems: StzhHeaderMenuItem[] = [];
  headerMetanavItems: StzhHeaderMetanavItem[] = [];

  footerLocalization = {
    legalNoticeUrl: 'ausschreibungsplattform-ahb-rechtliche-hinweise',
    legalNoticeText: 'Rechtliche Hinweise',
    imprintUrl: 'ausschreibungsplattform-ahb-impressum',
    imprintText: 'Impressum',
    accessibilityUrl: 'ausschreibungsplattform-ahb-barrierefreiheit',
    accessibilityText: 'Barrierefreiheit',
  };

  get footerMainUrl(): string {
    return this.ausschreibungService.getBaseUrl();
  }

  public selected: Observable<Ausschreibung | undefined>;

  constructor(
    private ausschreibungService: AusschreibungService,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
  ) {
    const checkLanding = (url: string) => url.split(/[?#]/)[0] === '/landing';
    this.isLanding = checkLanding(this.router.url);
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    ).subscribe(e => this.isLanding = checkLanding(e.urlAfterRedirects));

    this.ausschreibungService.isSignedIn().pipe(
      tap(signedIn => {
        this.signedIn = signedIn;
        if (signedIn && this.ausschreibungService.getSubmissionFromParam()) {
          this.router.navigate(['/ausschreibung/', this.ausschreibungService.getSubmissionFromParam()]);
        }
      }),
      switchMap(signedIn => signedIn
        ? this.ausschreibungService.me().pipe(map(me => me.fullname ?? 'Mein Konto'))
        : of('Mein Konto')),
    ).subscribe(user => this.buildHeaderItems(this.signedIn, user));

    this.selected = this.ausschreibungService.get();
    this.selected.subscribe(next => {
      if (!next) return;
      this.selectedAusschreibungTitle = next.objekt ?? '';
      this.id = next.id ?? '-1';
      this.angebot = next.angebot !== undefined;
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  addBaseUrl = (path: string) => `${this.ausschreibungService.getBaseUrl()}/${path}`;

  private buildHeaderItems(signedIn: boolean, user: string): void {
    this.headerMenuItems = [{
      label: 'Hilfe zur Angebotseingabe',
      href: this.addBaseUrl('ahb-hilfe-angebotseingabe'),
    }];

    const meinKonto: StzhHeaderMetanavItem = {
      label: user,
      labelShort: 'Mein Konto',
      icon: 'user',
      stay: true,
    };
    if (signedIn) {
      meinKonto.items = [
        {label: 'Benutzerdaten bearbeiten', href: this.addBaseUrl('app/mkfewww/web/auth/settings')},
        {label: 'Über «Mein Konto»', href: this.addBaseUrl('meinkonto')},
      ];
      meinKonto.itemButton = {label: 'Abmelden', href: 'oauth2/logout'};
    } else {
      meinKonto.href = 'oauth2/authorization/mein-konto-stadt-zh';
    }
    this.headerMetanavItems = [meinKonto];
  }
}
